module.exports = __webpack_public_path__ + "img/Vector 42.24cc9919.png";